import React from 'react';
import { useSelector } from 'react-redux';

import BreadcrumbsCProfile from '@src/components/Breadcrumbs/connectors/profile';
import { getSeo } from '@src/containers/Session/selectors/getSeo';

import ProfileTitle from '..';

const FrozenTitle = React.memo(
	(props) => {
		return <ProfileTitle {...props} />;
	},
	(prev, next) => {
		if (!next.label && !!prev.label) return true;
		return prev === next;
	},
);

const ProfileTitleCVenue = () => {
	const seo = useSelector(getSeo);
	return (
		<FrozenTitle
			label={seo?.background?.h1}
			BreadcrumbsRP={BreadcrumbsCProfile}
		/>
	);
};

export default ProfileTitleCVenue;
